import type { ApiOnboardingGraph, Node, PasteNodeData } from '@onefootprint/request-types/dashboard';

export const getNodeSubject = (graph: ApiOnboardingGraph, node: Node) => {
  if (node.subgraphId) {
    return 'person';
  }
  return graph.subject;
};

/** Returns a function to hydrate a given `node` with its `subject` information from the provided `graph`. */
export const withSubject =
  (graph: ApiOnboardingGraph) =>
  (node: Node): PasteNodeData => ({
    ...node,
    subject: getNodeSubject(graph, node),
  });
